// extracted by mini-css-extract-plugin
export default {"search-container":"awgdh","wrapper-section":"WqIzR","wrapper-section__fixed-bottom":"Vnp4M"};